import { getMetadataId } from '@modules/common/hooks/useGetBucketLabel/getMetadataId';
import { BucketParamsFragment } from 'generated/graphql';
import { encodeSourceToString } from 'v2/core/services/queryBuilder/utils';

export function getDataPointId(bucket: BucketParamsFragment): string {
  const {
    entitySentiment,
    labelID,
    language,
    metadata,
    source,
    namespace,
    timestamp,
    bucketID,
  } = bucket;

  if (bucketID) {
    return bucketID;
  }

  if (labelID) {
    return labelID;
  }

  if (source) {
    return encodeSourceToString({ name: source, namespace });
  }

  if (entitySentiment) {
    return entitySentiment;
  }

  if (language) {
    return language.iso6393;
  }

  if (metadata) {
    return getMetadataId(bucket.metadata);
  }

  if (timestamp) {
    return String(timestamp);
  }

  return '';
}
